var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 205.6 205.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272b52;}.cls-1,.cls-7,.cls-8{opacity:0.05;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{opacity:0.5;fill:url(#linear-gradient-3);}.cls-5{opacity:0.6;}.cls-6{fill:#fff;}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.15,
    y1: 202.97,
    x2: 87.15,
    y2: -59.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b0066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#175fc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#009cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00bcf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#00e1e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00f7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 91.25,
    y1: 5.92,
    x2: 91.25,
    y2: 452.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 101.01,
    y1: 169.42,
    x2: 101.01,
    y2: 226.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 102.8,
    y1: 51.8,
    x2: 102.8,
    y2: 207.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#13152b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04040d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 136.39,
    y1: 103.06,
    x2: 227.4,
    y2: 103.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 93.34,
    y1: 38.18,
    x2: 97.44,
    y2: 174.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4fff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#66e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5326ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 110.67,
    y1: 109.57,
    x2: 178.5,
    y2: 214.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6fff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#66e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7126ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 101.87,
    y1: 116.86,
    x2: 143.49,
    y2: 158.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 95.05,
    y1: 165.39,
    x2: 95.05,
    y2: 28.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4fff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#66e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7126ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 54.28,
    y1: 151.03,
    x2: 54.28,
    y2: 185.82,
    gradientTransform: "translate(138.07 -15.9) rotate(43.54)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.8,0A102.8,102.8,0,1,0,205.6,102.8,102.8,102.8,0,0,0,102.8,0Zm0,188.17a85.38,85.38,0,1,1,85.37-85.37A85.37,85.37,0,0,1,102.8,188.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.39,157.42a85.18,85.18,0,0,1-63.73,30.73c-47.16,1-86.57-37-87.23-84.14a85.36,85.36,0,0,1,151-55.84h0a15.67,15.67,0,0,0,.35-24.23A102.4,102.4,0,0,0,101.35,0C46,.77.78,46,0,101.33a102.8,102.8,0,0,0,168.7,80.35,15.68,15.68,0,0,0-.32-24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.8,9.13a93.67,93.67,0,1,0,70.56,155.25c-.14-.41-.31-.8-.48-1.19l-.24-.5c-.2-.41-.41-.8-.65-1.19-.06-.1-.14-.2-.2-.31-.22-.34-.46-.68-.71-1l-.23-.31a14.85,14.85,0,0,0-1-1.12,3,3,0,0,0-.25-.25,15.87,15.87,0,0,0-1.21-1.09h0q-2.17,2.61-4.55,5h0c-.22.24-.46.46-.69.69h0q-1.43,1.42-2.91,2.79l-.4.36h0c-.31.28-.61.56-.93.83h0l-.78.67h0l-1.15,1-.6.49h0l-1,.76h0c-.27.22-.56.43-.83.64h0l-1,.73h0l-.41.3c-.48.35-.95.7-1.43,1h0c-.29.21-.59.41-.89.61h0l-1.15.78-.74.48h0l-1,.64h0l-.51.32c-.61.37-1.22.74-1.83,1.09l-.55.32h0l-1,.58h0l-1,.53h0l-1.78.93-.25.12h0c-1.85.93-3.75,1.8-5.67,2.6l-.6.24h0l-1.11.44h0l-1,.4h0l-1.89.68-.28.1h0l-1.59.52-.61.2h0l-1.15.35h0l-.63.18c-.54.16-1.07.31-1.61.45h0l-.36.09c-1.38.37-2.78.7-4.19,1h0l-.69.14-1.63.31h0l-.86.15-1.61.26-1,.14h0l-1.23.16h0l-.42,0c-.65.08-1.3.15-2,.21h0l-1.14.1h0c-.66.06-1.32.1-2,.14l-.41,0h0c-.75,0-1.49.07-2.24.09h-2.54l-.89,0h0l-1.35,0h0c-1.49,0-3-.12-4.43-.24h-.1c-1-.09-2.1-.2-3.13-.32l-1.28-.16c-.74-.1-1.49-.21-2.23-.33a85.44,85.44,0,0,1-69.36-64.18c-.14-.57-.28-1.14-.4-1.71s-.21-1-.31-1.48c-.19-.91-.36-1.83-.52-2.75,0-.24-.07-.48-.11-.72q-.48-3-.74-6h0c0-.32-.05-.63-.08-1-.06-.84-.11-1.69-.15-2.54v0h0c0-.57-.05-1.15-.06-1.72,0-.15,0-.3,0-.45s0-.33,0-.49v-.61c0-.2,0-.4,0-.6s0-.34,0-.51c0-.59,0-1.18,0-1.76,0-.15,0-.3,0-.46h0c0-.36,0-.72,0-1.08h0l.06-1.11h0c0-.36,0-.72.07-1.08h0c0-.37.05-.74.08-1.1h0c0-.36.06-.72.1-1.07h0a2.83,2.83,0,0,1,0-.29c.14-1.35.3-2.69.49-4h0a.5.5,0,0,0,0-.12c.1-.67.21-1.34.32-2h0c0-.12,0-.23.07-.35.1-.59.21-1.17.32-1.76h0c.07-.35.15-.7.22-1h0c.1-.49.21-1,.32-1.45l.15-.63h0c.08-.35.16-.68.25-1h0l.06-.23c.2-.82.42-1.64.66-2.45,0-.13.07-.26.11-.4h0c.17-.57.34-1.14.52-1.71,0-.1.06-.2.1-.31h0c.32-1,.65-2,1-3h0l.09-.25c.2-.57.42-1.15.64-1.72h0l.39-1h0L24,70h0c.14-.32.28-.65.41-1h0c.25-.6.52-1.19.79-1.79a.37.37,0,0,0,.05-.11h0l.57-1.2.33-.68h0c.46-.93.93-1.85,1.42-2.76h0c0-.09.09-.18.14-.27.74-1.35,1.5-2.68,2.3-4l.15-.24h0l.75-1.19.36-.55h0l.56-.85h0l.42-.61c.24-.37.49-.73.75-1.09h0l.26-.36c.71-1,1.44-2,2.19-2.95h0l.42-.53.87-1.08h0c.22-.27.44-.54.67-.8h0l1.21-1.41.13-.14h0c.33-.38.67-.76,1-1.13l.37-.4h0l.69-.74h0c.24-.26.48-.51.73-.76h0c.37-.38.74-.76,1.12-1.13L43,41.9h0c.73-.72,1.47-1.43,2.22-2.12h0l.43-.38,1.1-1h0l.79-.68h0l.77-.65h0l.47-.38c.9-.74,1.83-1.47,2.77-2.18h0l.84-.62h0c.27-.2.54-.4.82-.59h0c.28-.21.57-.41.86-.61h0c.27-.2.54-.39.82-.57h0l.88-.59h0l.84-.55h0l.53-.34,1.22-.76h0l.32-.19c.48-.29,1-.59,1.46-.87h0l.92-.52h0c.89-.51,1.8-1,2.71-1.47h0l1-.47h0l.9-.45h0l.83-.39L67.71,25l.8-.35h0l.92-.4h0l.08,0c.61-.26,1.23-.52,1.86-.76h0c.33-.14.67-.26,1-.39h0l1.31-.49.66-.24h0L75.3,22h0l1-.34h0c.6-.2,1.19-.38,1.79-.56l.22-.07h0l1-.29h0l.59-.16c2.69-.75,5.43-1.36,8.22-1.85l.6-.1h0l1.65-.26.48-.07h0l1-.13h0l.55-.07c.81-.09,1.61-.18,2.42-.25l.43,0h0c1.2-.11,2.39-.19,3.6-.24l.94,0h.07c1,0,1.93-.06,2.9-.06a85.17,85.17,0,0,1,65.59,30.75,14,14,0,0,0,1.21-1.09l.25-.24a15,15,0,0,0,1-1.13l.23-.3c.25-.33.48-.66.71-1l.2-.31c.24-.38.45-.78.65-1.18.08-.17.16-.33.23-.5.18-.39.35-.79.49-1.19A93.41,93.41,0,0,0,102.8,9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.43,160.29c-.33-.32-.67-.63-1-.93h0q-2.17,2.61-4.55,5h0l-.69.69q-1.43,1.42-2.91,2.79c-.14.11-.27.23-.4.35h0l-.93.83h0l-.78.67h0l-1.15,1-.6.49h0l-1,.76h0l-.83.64h0l-1,.73h0l-.41.3-1.43,1h0c-.29.21-.59.41-.89.61h0c-.38.26-.76.52-1.15.77l-.74.49h0l-1,.64h0l-.51.32-1.83,1.09-.55.32h0l-1,.58h0l-1,.53h0l-1.78.92-.25.13h0c-1.85.93-3.75,1.8-5.67,2.59l-.6.25h0l-1.11.44h0l-1,.39h0c-.62.24-1.26.46-1.89.68l-.28.1h0l-1.59.53-.61.19h0l-1.15.36h0l-.63.18-1.61.45h0l-.36.09c-1.38.36-2.78.69-4.19,1h0l-.69.14-1.63.31h0l-.86.15-1.61.26-1,.14h0l-1.23.16h0l-.42,0-2,.21h0l-1.14.1h0c-.66.05-1.32.1-2,.13l-.41,0h0c-.75,0-1.49.07-2.24.09h-3.44l-1.35,0h0c-1.49,0-3-.12-4.43-.24h-.1c-1-.09-2.1-.2-3.13-.32l-1.28-.16c-.74-.1-1.49-.22-2.23-.34a85.36,85.36,0,0,1-56.6-35.72c8.41,23,36.58,39.92,70.05,39.92C132.62,193.2,158.34,179.64,169.43,160.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.37,41.22A93.64,93.64,0,0,0,18.82,61.76a100.54,100.54,0,0,0-5.23,13.15,103,103,0,0,0-3.16,13.78,107.4,107.4,0,0,0-1,14.11,107.38,107.38,0,0,0,1,14.1,103.5,103.5,0,0,0,3.16,13.79,100.41,100.41,0,0,0,5.23,13.14,93.6,93.6,0,0,0,154.55,20.55,93.72,93.72,0,0,1-147.7-8.14A95.05,95.05,0,0,1,18.45,144a101.34,101.34,0,0,1-5.28-13.19A102.94,102.94,0,0,1,10,117,103.38,103.38,0,0,1,8.89,102.8,105.13,105.13,0,0,1,10,88.62a104,104,0,0,1,3.2-13.84,102.32,102.32,0,0,1,5.28-13.2,96.22,96.22,0,0,1,7.22-12.23,93.76,93.76,0,0,1,147.7-8.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.44,105.47l1.37-14.31,38.74,29.37a38.12,38.12,0,1,0-33.75,20.39h.37A64.07,64.07,0,0,1,96.44,105.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.8,31.51a71.29,71.29,0,1,0,33.78,134.07l-27.41-12.52a51.5,51.5,0,0,1-6.37.41,50.68,50.68,0,1,1,22.57-5.31l16.92,14A71.29,71.29,0,0,0,102.8,31.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.18,153.06a51.66,51.66,0,0,1-6.38.41A50.68,50.68,0,1,1,129,59.4a24.86,24.86,0,0,0,28.75-2h0a71.31,71.31,0,1,0-21.18,108.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.8,102.8v7.53a40.75,40.75,0,0,0,14.8,31.42h0l24.67,20.37h0l0,0,.12-.1.17-.12a15.71,15.71,0,0,0,1.12-25.06l-2-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M134.71,142.6l-31.44-26.18a40.33,40.33,0,0,0,14.33,25.33h0l24.67,20.37h0l0,0,.12-.1.17-.12a15.22,15.22,0,0,0,6-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.49,62.14A61.15,61.15,0,1,0,124.43,160l-15.25-7a51.66,51.66,0,0,1-6.38.41c-.89,0-1.77,0-2.64-.07-.29,0-.58-.05-.86-.07-.59,0-1.17-.07-1.75-.13l-1-.13c-.52-.06-1-.12-1.55-.2l-1.08-.19-1.44-.27-1.1-.25L90,151.83l-1.1-.31c-.45-.13-.89-.25-1.33-.39l-1.09-.37c-.43-.15-.87-.29-1.29-.45s-.72-.28-1.08-.42-.83-.33-1.24-.51-.71-.32-1.07-.48l-1.2-.55-1-.54c-.39-.2-.78-.4-1.16-.61s-.68-.39-1-.59-.75-.43-1.12-.66l-1-.63c-.37-.24-.73-.47-1.08-.72s-.65-.45-1-.68-.7-.5-1-.76-.62-.49-.93-.73l-1-.81-.89-.78-1-.85-.85-.82c-.31-.29-.61-.59-.91-.9s-.55-.56-.82-.85-.58-.63-.86-.95-.52-.59-.78-.89l-.82-1c-.24-.31-.49-.62-.73-.94s-.51-.68-.77-1l-.69-1c-.24-.35-.48-.7-.71-1.06l-.65-1-.66-1.1-.6-1-.61-1.13-.55-1.07c-.19-.39-.37-.78-.55-1.17s-.34-.72-.5-1.09-.34-.8-.5-1.2-.3-.74-.44-1.12-.3-.81-.44-1.22-.27-.77-.39-1.15-.26-.84-.38-1.26-.23-.77-.33-1.17-.22-.85-.32-1.28-.19-.79-.28-1.19-.17-.87-.26-1.31-.15-.8-.21-1.21-.13-.89-.19-1.34-.11-.81-.16-1.22-.08-.91-.12-1.36-.07-.83-.09-1.24,0-.92-.06-1.38,0-.84,0-1.26c0-.1,0-.21,0-.31,0-.37,0-.74,0-1.1s0-.65,0-1c0-.09,0-.19,0-.28,0-.35,0-.7.07-1s.06-1,.11-1.44.08-.77.13-1.16.1-.83.16-1.24.14-.92.22-1.38.11-.62.17-.93c.1-.56.22-1.11.35-1.66l.12-.55c.16-.67.33-1.33.52-2l0-.11A50.77,50.77,0,0,1,88.21,54.26l.1,0c.7-.21,1.41-.41,2.13-.59l.63-.15c.55-.13,1.1-.26,1.66-.37s1.16-.22,1.74-.31l.63-.12c.83-.12,1.66-.23,2.5-.31l.26,0c.69-.07,1.38-.13,2.08-.17h.16l.44,0c.64,0,1.28,0,1.92,0h.69c.8,0,1.59,0,2.37.07h.25c.86,0,1.71.13,2.55.22l.63.07c.76.1,1.52.2,2.27.33l.28,0c.82.14,1.64.31,2.45.49l.61.15c.72.17,1.44.35,2.15.55l.3.09q1.18.35,2.34.75l.58.2c.68.25,1.36.51,2,.78l.31.13c.75.31,1.49.64,2.23,1l.54.26c.64.32,1.27.64,1.89,1l.32.17c.58.32,1.16.65,1.72,1A25,25,0,0,0,148.49,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M107.42,155.65c0-.28,0-.57-.07-.85h0c-1.37.16-2.75.26-4.13.31h0l-.59,0q-1.23,0-2.46,0h-.33l-.75,0h0l-.63,0h0l-.91-.06-.47,0h0l-.74-.07h0l-.64-.06h0l-.73-.09h0l-.31,0-1.06-.14h0l-.65-.1h0l-.83-.14-.53-.1h0l-.71-.14h0l-.36-.08-1.27-.28-.38-.09h0l-.7-.18h0l-.64-.17h0L86.34,153l-.16-.05h0c-1.21-.36-2.41-.78-3.59-1.23l-.37-.15h0c-.23-.08-.45-.17-.67-.27h0l-.63-.26h0l-1.12-.49-.17-.08h0l-.92-.43-.35-.17h0l-.66-.33h0l-.36-.19-.89-.47h0l-.2-.11c-.76-.42-1.52-.86-2.26-1.32h0l-.35-.23-.86-.55h0l-.44-.29c-.27-.19-.55-.37-.82-.57l-.5-.35h0L70.4,145h0l-.2-.15-1-.74h0l-.55-.43h0l-.94-.77-.19-.16h0l-1-.91-.08-.07-.14-.12-.51-.48-.32-.3-.08-.07h0L65,140.4h0l-.59-.57h0c-.64-.65-1.25-1.3-1.85-2l0,0c-.43-.48-.84-1-1.25-1.46l-.5-.61q-.42-.53-.84-1.08A51.92,51.92,0,0,1,50,95.15c-5.94,13.68-.6,33,14.18,47C77.36,154.73,94.4,159.53,107.42,155.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.5,62.13a61.4,61.4,0,0,0-27.66-17.6,58.86,58.86,0,0,0-16.3-2.65,60.86,60.86,0,0,0-60.79,46.4,60.76,60.76,0,0,0,18.64,60.1,61.42,61.42,0,0,0,62,11.65A61.31,61.31,0,0,1,44.08,121.1,61.39,61.39,0,0,1,88,43.17a61.07,61.07,0,0,1,16.54-1.72,62.5,62.5,0,0,1,8.3.79A61,61,0,0,1,148.5,62.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.55,154.13c-3.87-3-7.69-6.11-11.5-9.21l-11.38-9.36-11.26-9.49c-3.74-3.19-7.47-6.39-11.14-9.65,3.87,3,7.69,6.11,11.51,9.2L126.15,135l11.27,9.49C141.15,147.67,144.88,150.87,148.55,154.13Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/LogoBlue.51aa571fc4613936265d5a8c337974da.svg";
export { ForwardRef as ReactComponent };